var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{on:{"click":_vm.handleClick}},[_c(_vm.svg,{tag:"component",staticClass:"leading-none",attrs:{"width":_vm.computedSize.width,"height":_vm.computedSize.height,"stroke":_vm.stroke,"fill":_vm.fill ? 'currentColor' : undefined}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }